// global.js
export default {
    base_url: process.env.VUE_APP_BASE_URL,
    base_upload_url: process.env.VUE_APP_UPLOAD_URL,
    preview_path_url: process.env.VUE_APP_PREVIEW_URL,
}
